{
  "campaignName": "",
  "platform": "Ether.fi",
  "description": "Points for providing liquidity.",
  "platformImageId": "etherfi.png",
  "dashboardLink": "https://app.ether.fi/defi",
  "pools": [
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x278cfb6f06b1efc09d34fc7127d6060c61d629db",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xdb74dfdd3bb46be8ce6c33dc9d82777bcfc3ded5",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x6683eafe46cb9ed394f298e14b87ed680c17cedd",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xb9ef9c471f686e9249f5bb3af465560e4b917294",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x2fd6965730bef5c7e928342ad6e7d4819d08f8c4",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xcccd572b22dee28479b11dd99589a1e4c0682a7e",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x6a8a274a670484fc358ab5ae00a1e0aa9ab11ae6",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xb92b054b9cc33685e7f8c3f85177c4b6dc061391",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x7704d01908afd31bf647d969c295bb45230cd2d6",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xabaf76590478f2fe0b396996f55f0b61101e9502",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "borrow",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x652aEa6B22310C89DCc506710CaD24d2Dba56B11",
      "network": "ethereum",
      "multiplier": "2x",
      "tags": ["points"],
      "lock": "false"
    }
  ]
}
